<template>
  <article class="section-container bg-qwraylight">
    <section class=" TextCol">
      <div class="SpaceTop" />
      <div class="Title">{{ $t('accreditations.big_header') }}</div>
      <div class="Text">
        <div style="margin-top: 1em;">
          {{ $t('accreditations.subtitle') }}
        </div>
      </div>
    </section>
    <div
      class="bg-white rounded md:rounded-xl h-full certificate-container flex flex-col justify-evenly space-y-5f"
    >
      <div>
        <div class="relative">
          <p class="relative z-10 text-2xl text-qwray font-lato">
            Our certificates
          </p>
          <div class="highlightBox" />
        </div>
        <div
          style="column-gap: 14px; row-gap: 15px; align-items: center;"
          class="flex flex-wrap mt-5  mb-10  justify-evenly certificates-mobile"
        >
          <img
            alt="livingWage"
            class="image img-item-1"
            width="126"
            :src="require('@/' + livingWage)"
          />

          <a
            class="img-item"
            href="https://www.nqa.com/en-gb/certification/standards/iso-9001"
          >
            <div>
              <img
                src="https://www.nqa.com/medialibraries/NQA/NQA-Media-Library/CertificationLogos/NQA-ISO-9001-Logo.jpg"
                alt="nqa-iso-9001"
                width="67"
              />
            </div>
          </a>
          <a
            class="img-item"
            href="https://www.nqa.com/en-gb/certification/standards/iso-14001"
          >
            <div>
              <img
                src="https://www.nqa.com/medialibraries/NQA/NQA-Media-Library/CertificationLogos/NQA-ISO-14001-Logo.jpg"
                alt="nqa-iso-14001"
                width="67"
              />
            </div>
          </a>
          <a
            class="img-item"
            href="https://www.nqa.com/en-gb/certification/standards/iso-22301"
          >
            <div>
              <img
                src="https://www.nqa.com/medialibraries/NQA/NQA-Media-Library/CertificationLogos/NQA-ISO-22301-Logo.jpg"
                alt="nqa-iso-22301"
                width="67"
              />
            </div>
          </a>
          <a
            class="img-item"
            href="https://www.nqa.com/en-gb/certification/standards/iso-27001"
          >
            <div>
              <img
                src="https://www.nqa.com/medialibraries/NQA/NQA-Media-Library/CertificationLogos/NQA-ISO-27001-Logo.jpg"
                alt="nqa-iso-27001"
                width="67"
              />
            </div>
          </a>
          <img
            alt="cyperEssentials"
            class="image img-item-2"
            :src="require('@/' + cyperEssentials)"
          />

          <img
            alt="greenly"
            class="image img-item-3"
            width="114"
            height="100"
            :src="require('@/' + greenly)"
          />
          <img
            alt="greenFleet"
            class="image img-item-4"
            width="136"
            height="200"
            :src="require('@/' + greenFleet)"
          />
        </div>

        <div class="mt-5 certificates-desktop mb-5">
          <section class="embla">
            <div class="embla__viewport">
              <div class="embla__container px-5">
                <div class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <img
                        alt="livingWage"
                        class="image img-item-1"
                        width="126"
                        :src="require('@/' + livingWage)"
                      />
                    </div>
                  </div>
                </div>
                <div class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <a
                        class="img-item"
                        href="https://www.nqa.com/en-gb/certification/standards/iso-9001"
                      >
                        <div>
                          <img
                            src="https://www.nqa.com/medialibraries/NQA/NQA-Media-Library/CertificationLogos/NQA-ISO-9001-Logo.jpg"
                            alt="nqa-iso-9001"
                            width="67"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <a
                        class="img-item"
                        href="https://www.nqa.com/en-gb/certification/standards/iso-14001"
                      >
                        <div>
                          <img
                            src="https://www.nqa.com/medialibraries/NQA/NQA-Media-Library/CertificationLogos/NQA-ISO-14001-Logo.jpg"
                            alt="nqa-iso-14001"
                            width="67"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <a
                        class="img-item"
                        href="https://www.nqa.com/en-gb/certification/standards/iso-22301"
                      >
                        <div>
                          <img
                            src="https://www.nqa.com/medialibraries/NQA/NQA-Media-Library/CertificationLogos/NQA-ISO-22301-Logo.jpg"
                            alt="nqa-iso-22301"
                            width="67"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <a
                        class="img-item"
                        href="https://www.nqa.com/en-gb/certification/standards/iso-27001"
                      >
                        <div>
                          <img
                            src="https://www.nqa.com/medialibraries/NQA/NQA-Media-Library/CertificationLogos/NQA-ISO-27001-Logo.jpg"
                            alt="nqa-iso-27001"
                            width="67"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <img
                        alt="cyperEssentials"
                        class="image img-item-2"
                        :src="require('@/' + cyperEssentials)"
                      />
                    </div>
                  </div>
                </div>
                <div class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <img
                        alt="greenly"
                        class="image img-item-3"
                        width="114"
                        height="100"
                        :src="require('@/' + greenly)"
                      />
                    </div>
                  </div>
                </div>
                <div class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <img
                        alt="greenFleet"
                        class="image img-item-4"
                        width="68"
                        height="100"
                        :src="require('@/' + greenFleet)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <button
                class="embla__button embla_button--certificates embla__button--prev"
                type="button"
              >
                <svg class="embla__button__svg" viewBox="0 0 532 532">
                  <path
                    fill="#FFDF22"
                    d="M355.66 11.354c13.793-13.805 36.208-13.805 50.001 0 13.785 13.804 13.785 36.238 0 50.034L201.22 266l204.442 204.61c13.785 13.805 13.785 36.239 0 50.044-13.793 13.796-36.208 13.796-50.002 0a5994246.277 5994246.277 0 0 0-229.332-229.454 35.065 35.065 0 0 1-10.326-25.126c0-9.2 3.393-18.26 10.326-25.2C172.192 194.973 332.731 34.31 355.66 11.354Z"
                  ></path>
                </svg>
              </button>

              <button
                class="embla__button embla_button--certificates embla__button--next"
                type="button"
              >
                <svg class="embla__button__svg" viewBox="0 0 532 532">
                  <path
                    fill="#FFDF22"
                    d="M176.34 520.646c-13.793 13.805-36.208 13.805-50.001 0-13.785-13.804-13.785-36.238 0-50.034L330.78 266 126.34 61.391c-13.785-13.805-13.785-36.239 0-50.044 13.793-13.796 36.208-13.796 50.002 0 22.928 22.947 206.395 206.507 229.332 229.454a35.065 35.065 0 0 1 10.326 25.126c0 9.2-3.393 18.26-10.326 25.2-45.865 45.901-206.404 206.564-229.332 229.52Z"
                  ></path>
                </svg>
              </button>
            </div>
          </section>
        </div>
      </div>
      <div>
        <div class="relative">
          <p class="relative z-10 text-2xl text-qwray font-lato">
            Our Partners
          </p>
          <div class="highlightBox" />
        </div>
        <div
          style="column-gap: 40px; row-gap: 10px"
          class="flex flex-wrap mt-5  partners-mobile"
        >
          <img
            v-for="img in partners"
            :key="img"
            :alt="img"
            class="image partner-img-item"
            :src="require('@/' + img)"
          />
        </div>
        <div class="mt-5 partners-desktop mb-5">
          <section class="embla">
            <div class="embla__viewport">
              <div class="embla__container px-5">
                <div v-for="img in partners" :key="img" class="embla__slide">
                  <div class="embla__slide__number" style="height: 100%;">
                    <div class="flex items-center">
                      <img
                        :alt="img"
                        class="image"
                        width="100"
                        :src="require('@/' + img)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <button class="embla__button embla__button--prev" type="button">
                <svg class="embla__button__svg" viewBox="0 0 532 532">
                  <path
                    fill="#FFDF22"
                    d="M355.66 11.354c13.793-13.805 36.208-13.805 50.001 0 13.785 13.804 13.785 36.238 0 50.034L201.22 266l204.442 204.61c13.785 13.805 13.785 36.239 0 50.044-13.793 13.796-36.208 13.796-50.002 0a5994246.277 5994246.277 0 0 0-229.332-229.454 35.065 35.065 0 0 1-10.326-25.126c0-9.2 3.393-18.26 10.326-25.2C172.192 194.973 332.731 34.31 355.66 11.354Z"
                  ></path>
                </svg>
              </button>

              <button class="embla__button embla__button--next" type="button">
                <svg class="embla__button__svg" viewBox="0 0 532 532">
                  <path
                    fill="#FFDF22"
                    d="M176.34 520.646c-13.793 13.805-36.208 13.805-50.001 0-13.785-13.804-13.785-36.238 0-50.034L330.78 266 126.34 61.391c-13.785-13.805-13.785-36.239 0-50.044 13.793-13.796 36.208-13.796 50.002 0 22.928 22.947 206.395 206.507 229.332 229.454a35.065 35.065 0 0 1 10.326 25.126c0 9.2-3.393 18.26-10.326 25.2-45.865 45.901-206.404 206.564-229.332 229.52Z"
                  ></path>
                </svg>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { entity } from '../../../region.json';
// eslint-disable-next-line import/extensions
import initCarousel from '../../ts/index.js';
import '../../assets/css/embla.css';

export default {
  name: 'Pricing',
  props: ['tariffRef'],
  data() {
    return {
      entity,
    };
  },
  mounted() {
    initCarousel();
  },
  computed: {
    cyperEssentials() {
      return 'assets/certificates/cyperEssentials@2x.webp';
    },
    greenly() {
      return 'assets/certificates/greenly@2x.webp';
    },
    greenFleet() {
      return 'assets/certificates/greenfleet@2x.webp';
    },
    livingWage() {
      return 'assets/certificates/livingWage@2x.webp';
    },
    partners() {
      return [
        'assets/partners/CCC.webp',
        'assets/partners/CCSS.webp',
        'assets/partners/DDN.webp',
        'assets/partners/DHG.webp',
        'assets/partners/ECC.webp',
        'assets/partners/heartCity.webp',
        'assets/partners/OZV.webp',
        'assets/partners/REA.webp',
        'assets/partners/SMB.webp',
      ];
    },
  },
};
</script>

<style scoped>
.section-container {
  padding: 36px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.certificate-container {
  width: 100%;
  height: 600px;
  border-radius: 16px;
  padding: 36px 20px;
}

.highlightBox {
  background-color: #ffdf22;
  width: 170px;
  height: 16px;
  top: 20px;
  position: absolute;
}

.partners-desktop {
  display: none;
}

.partners-mobile {
  display: flex;
}

.certificates-desktop {
  display: none;
}

.certificates-mobile {
  display: flex;
}

.embla_button--certificates {
  top: 20%;
}

.partner-img-item {
  display: flex;
  align-items: center;
  width: 75px;
  object-fit: contain;
}

.img-item {
  display: flex;
  align-items: center;
  width: 54px;
  object-fit: contain;
}

.img-item-1 {
  display: flex;
  align-items: center;
  width: 87px;
  object-fit: contain;

  height: 100%;
}

.img-item-2 {
  display: flex;
  align-items: center;
  width: 67px;
  object-fit: contain;

  height: 100%;
}

.img-item-3 {
  display: flex;
  align-items: center;
  width: 70px;
  object-fit: contain;

  height: 100%;
}
.img-item-4 {
  display: flex;
  align-items: center;
  width: 68px;
  object-fit: contain;

  height: 100%;
}

@media (min-width: 850px) {
  .section-container {
    padding: 50px 45px;
    display: flex;
    justify-content: center;
    flex-direction: row;
  }

  .certificate-container {
    width: 100%;
    height: 520px;
    border-radius: 50px;
    padding: 0px 36px;
  }
}
@media (min-width: 1024px) {
  .img-item {
    display: flex;
    align-items: center;
    width: 67px;
  }
  .img-item-1 {
    display: flex;
    align-items: center;
    width: 126px;
  }
  .img-item-2 {
    display: flex;
    align-items: center;
    width: 93px;
  }
  .img-item-3 {
    display: flex;
    align-items: center;
    width: 114px;
  }
  .img-item-4 {
    display: flex;
    align-items: center;
    width: 110px;
  }
  .partners-desktop {
    display: block;
  }

  .partners-mobile {
    display: none;
  }
  .certificates-desktop {
    display: block;
  }

  .certificates-mobile {
    display: none;
  }
}
</style>

<style scoped>
article {
  --day-bg: #ffffff;
  --day-color: #2b4047;
  --day-time-text-color: #5e7177;
  --day-title-color: #2b4047;
  --night-bg: #2b4047;
  --night-color: #ffffff;
  --night-time-text-color: #a1b1b5;
  --night-title-color: #ffffff;
  --price-title-f-size: 24px;
  --price-title-margin: 12px;
  --rect-h: 266px;
  --rect-w: 200px;
  --day-margin-right: 0;
  --day-margin-bottom: 1.5em;
  --space-top: 92px;
  --space-bottom: 70px;
  --text-color: white;
  --max-f-size: 14px;
  --time-f-size: 14px;
  --time-margin: 3px;
  --metrics-f-size: 20px;
  --details-f-size: 10px;
  --subtitle-margin: 32px;
  --subtitle-f-size: 16px;
  --title-margin: 32px;
  --title-f-size: 30px;
  --text-margin: 64px;
  --text-f-size: 14px;
  --price-grid-margin: 26px;
  --grid-gap: 4px;
  --charge-svg-size: 100%;
  --metrics-svg-size: 100%;
  --flex-m-top: 34px;
  --underline-width: 80px;
  --city-btn-f-size: 14px;
}
.SpaceTop {
}
.SpaceBottom {
  height: var(--space-bottom);
}

.Subtitle {
  font-size: var(--subtitle-f-size);
  color: var(--day-time-text-color);
  letter-spacing: 2.4px;
  margin-bottom: var(--subtitle-margin);
}
.Title {
  line-height: normal;
  font-size: var(--title-f-size);
  font-family: Foco;
  color: white;
  font-weight: bold;
  margin-bottom: var(--title-margin);
}
.Text {
  font-size: var(--text-f-size);
  color: var(--text-color);
  margin-bottom: var(--text-margin);
}

.TextCol {
  margin: auto;
  width: 90%;
}
@media (min-width: 500px) {
  article {
    --rect-w: 172px;
    --rect-h: 244px;
    --price-title-f-size: 19px;
    --time-f-size: 11px;
    --metrics-f-size: 13px;
    --max-f-size: 12px;
    --space-bottom: 120px;
    --day-margin-right: 1em;
    --day-margin-bottom: 0;
  }
  .TextCol {
    width: 57%;
    margin: 0;
    color: white;
  }
  .Flex {
    justify-content: center;
    flex-direction: row;
    align-items: stretch;
  }
}
@media (min-width: 880px) {
  article {
    --min-height: 100%;
    --space-bottom: 0px;
    margin-bottom: 5em;
    margin-top: 6em;
    --underline-width: 104px;
    --city-btn-f-size: 20px;
  }
  .PricingCol {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    max-width: 100%;
    margin: 0;
  }
  .TextCol {
    max-width: 100%;
    margin: 0;
  }
  .SpaceTop {
    height: var(--space-top);
  }
}
@media (min-width: 1026px) {
  article {
    --subtitle-f-size: 20px;
    --title-f-size: 30px;
    --text-f-size: 16px;
    --space-bottom: 0px;
    --details-f-size: 12px;
  }
  .Title,
  .Text {
    max-width: 95%;
  }
}
@media (min-width: 1271px) {
  article {
    --title-f-size: 50px;
    --text-f-size: 17px;
    --rect-h: 285px;
    --rect-w: 201px;
    --price-title-f-size: 22px;
    --time-f-size: 13px;
    --metrics-f-size: 16px;
  }
  .PricingRect {
    padding-top: 30px;
  }
  .Day > img {
    max-width: 100%;
    width: 58px;
  }
  .Night > img {
    max-width: 100%;
    width: 58px;
  }

  .Title {
    line-height: 1.3;
  }
  .Title,
  .Text {
    max-width: 90%;
  }
}

@media (min-width: 1350px) {
  article {
    --rect-h: 342px;
    --rect-w: 241px;
    --price-title-f-size: 26px;
    --time-f-size: 16px;
    --metrics-f-size: 19px;
    --price-title-margin: 22px;
    --max-f-size: 18px;
    --details-f-size: 16px;
  }

  .Title {
    line-height: 1.2;
  }
}

@media (min-width: 1750px) {
  article {
    --title-f-size: 70px;
    --text-f-size: 20px;
    --subtitle-margin: 40px;
    --title-margin: 60px;
    --rect-h: 446px;
    --rect-w: 314px;
    --price-title-f-size: 30px;
    --price-title-margin: 35px;
    --time-f-size: 20px;
    --time-margin: 4px;
    --metrics-f-size: 28px;
    --max-f-size: 24px;
    --price-grid-margin: 45px;
    --grid-gap: 8px;
    --day-margin-right: 2.8em;
    --flex-m-top: 92px;
    margin-top: 4em;
    margin-bottom: 6em;
  }
}
</style>
